import { fork } from 'redux-saga/effects';

import * as countries from './countries';
import * as countryDetails from './countryDetails';
import * as configurations from './configurations';
import * as publicConstants from './publicConstants';
import * as optAuthCodes from './optAuthCodes';

export default function* dataRootSaga() {
  yield fork(countries.watcher);
  yield fork(countryDetails.watcher);
  yield fork(configurations.watcher);
  yield fork(publicConstants.watcher);
  yield fork(optAuthCodes.watcher);
}



// WEBPACK FOOTER //
// ./src/redux/data/root-saga.js